
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
    state:{
      certId:'',
      isBack:false,
      currentRow:null,
    },
    getters:{
        getcertObj(state){
            return state.certId;
        },
        getisBack(state){
          return state.isBack;
      },
    },
    mutations:{
        editcert(state,str){//编辑
          state.certId=str
        },
        editisBack(state,boolean){//编辑
          state.isBack=boolean
        },
        editisCurrentRow(state,obj){//编辑
          state.currentRow=obj
        },
    }
  })


// WEBPACK FOOTER //
// ./src/components/store/store.js